import { CreateMunicipalPropertyInput } from "@/graphql/generated/graphql";

import { MunicipalPropertyCreateFormValues } from "./municipal-property-create-form-values";

type MunicipalPropertyMasterDataInput = Omit<
  CreateMunicipalPropertyInput,
  "workspaceId" | "municipalityIdList" | "effectiveYear"
>;

const toNullableText = (value: string): string | null => value || null;

export function toMunicipalPropertyMasterDataInput(
  values: MunicipalPropertyCreateFormValues,
): MunicipalPropertyMasterDataInput {
  return {
    name: values.name,
    type: values.type,
    description: toNullableText(values.description),
    street: toNullableText(values.street),
    houseNumber: toNullableText(values.houseNumber),
    postalCode: toNullableText(values.postalCode),
    city: toNullableText(values.city),
    usableFloorAreaM2: values.usableFloorAreaM2,
    commissioningYear: values.commissioningYear,
  };
}
